/* eslint-disable @typescript-eslint/camelcase */
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { Expose } from 'class-transformer'

export class AMLCsvModel extends CSVModelInterface {
  filename = 'AMLCSVTemplate'

  @Expose()
  private 'Policy Oid' = 'Policy Oid'

  get policyOid () {
    return this['Policy Oid']
  }

  @Expose()
  private 'Resolution Status' = 'Resolution Status'

  get resolutionStatus () {
    return this['Resolution Status']
  }

  @Expose()
  private 'Risk Status' = 'Risk Status'

  get riskStatus () {
    return this['Risk Status']
  }

  @Expose()
  private 'Reason' = 'Reason'

  get reason () {
    return this.Reason
  }

  @Expose()
  private 'Notes' = 'Notes'

  get notes () {
    return this.Notes
  }
}
